import type {del, get, post, put} from 'aws-amplify/api';

// Ces types (GetInput, GetOperation, …) ne sont exposés par AUCUNE entrée
// publique d'Amplify : ni `aws-amplify/api`, ni `@aws-amplify/api-rest`, dont
// l'`exports` map ne publie que `.`, `./server`, `./internals`,
// `./internals/server` et `./package.json`.
//
// Ce fichier les importait donc via un chemin profond
// (`@aws-amplify/api-rest/dist/esm/types`), qui ne se résout QU'EN
// `moduleResolution: "node"` — le seul mode qui ignore `exports`. Conséquence :
// la source de `contracts` était inconsommable par un workspace en résolution
// moderne (`bundler`/`node16`), ce qui obligeait tout consommateur à passer par
// `contracts/dist`.
//
// On les dérive donc des fonctions publiques. C'est indépendant du mode de
// résolution, et ça reste automatiquement aligné sur les vraies signatures
// d'Amplify.
type GetInput = Parameters<typeof get>[0];
type GetOperation = ReturnType<typeof get>;
type PostInput = Parameters<typeof post>[0];
type PostOperation = ReturnType<typeof post>;
type PutInput = Parameters<typeof put>[0];
type PutOperation = ReturnType<typeof put>;
type DeleteInput = Parameters<typeof del>[0];
type DeleteOperation = ReturnType<typeof del>;

export type GetMethod = 'GET';
export type PutMethod = 'PUT';
export type PostMethod = 'POST';
export type DeleteMethod = 'DELETE';
export type MethodBase = GetMethod | PutMethod | PostMethod | DeleteMethod;

export type InputOf<M extends MethodBase> = M extends GetMethod
  ? Omit<GetInput, 'apiName'>
  : M extends PutMethod
    ? Omit<PutInput, 'apiName'>
    : M extends PostMethod
      ? Omit<PostInput, 'apiName'>
      : M extends DeleteMethod
        ? Omit<DeleteInput, 'apiName'>
        : never;

type OperationOf<M extends MethodBase> = M extends GetMethod
  ? GetOperation
  : M extends PutMethod
    ? PutOperation
    : M extends PostMethod
      ? PostOperation
      : M extends DeleteMethod
        ? DeleteOperation
        : never;

export abstract class Command<Method extends MethodBase, Output = void> {
  constructor(
    public readonly method: (input: InputOf<Method> & {apiName: string}) => OperationOf<Method>,
    public readonly input: InputOf<Method>,
  ) {}

  abstract deserialize(output: OperationOf<Method>): Promise<Output>;
}
